<template>
  <div class="iv-difficult-apply iv-p-t-24 iv-p-b-40">
    <div class="iv-main-width">
      <Row class="iv-main-width iv-step-row" type="flex">
        <Col
          :style="{width: `${100/Number(stepList.length)}%`}"
          class="iv-step-col"
          :class="{'iv-step-col-color': item.status !== 'wait'}"
          v-for="(item, index) in stepList"
          :key="index">
          <div class="iv-step">
            <div
              class="iv-step-number"
              :class="{'iv-active-step': item.status !== 'wait', 'iv-finsh-step': item.status === 'complete'}">
              <IconFont v-if="item.status == 'complete'" type="tijiaoqueren" />
              <span
                v-else
                class="iv-fc-45 iv-fs-18"
                :class="{'iv-active-color': item.status === 'ongoing'}">
                {{ item.step }}
              </span>
            </div>
            <div class="iv-step-title">
              <span class="iv-fs-18" :class="{'iv-main-color': item.status !== 'wait'}">{{ item.title }}</span>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import IconFont from '@/components/iconfont'

export default {
  props: {
    stepData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      stepList: []
    }
  },
  watch: {
    stepData: {
      immediate: true,
      handler (val) {
        this.stepList = val
      }
    }
  },
  components: {
    IconFont
  }
}
</script>

<style lang="scss" scoped>
@import "variable/variable.scss";
.iv-difficult-apply {
  min-height: 100%;;
  background-color: #f9f9f9 !important;
}
.iv-step-row {
  height: 130px;
  background: #f9f9f9;
  .iv-step-col {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    position: relative;
    align-items: center;
    &:nth-child(n+2):after {
      content: '';
      width: 70%;
      left: -35%;
      height: 2px;
      background: rgba(0, 0, 0, 0.16);
      z-index: 1;
      position: absolute;
    }
    .iv-step {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .iv-step-number {
        border: 2px solid rgba(0, 0, 0, 0.24);
        width: 35px;
        height: 35px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .iv-step-title {
        position: absolute;
        bottom: 12px;
      }
    }
  }
  .iv-step-col-color {
    &:nth-child(n+2):after {
      background: $iv-main-color;
    }
  }
}
.iv-active-step {
  border: 2px solid $iv-main-color !important;
  background-color: $iv-main-color !important;
  .iv-active-color {
    color: #fff !important;
  }
}
.iv-finsh-step {
  border: 2px solid $iv-main-color !important;
  background-color: transparent !important;
  color: $iv-main-color !important;
}
</style>